export default {"and_chr":120,"android":120,"chrome":111,"edge":111,"firefox":78,"ios_saf":15.6,"opera":95,"safari":16};